import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full border-y border-stone-200 bg-white py-10 sm:py-14" data-id="element-187" data-mp="1tarjq9bipqkw">
      <div className="mx-auto max-w-6xl px-5" data-id="element-188" data-mp="1t8nkw5sh7hrh">
        <h2 className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-red-500" data-id="element-189" data-mp="1oac9vrqg317o">
          The Numbers Don&apos;t Lie
        </h2>
        <dl className="mt-8 grid grid-cols-2 gap-y-8 md:grid-cols-4 md:gap-y-0" data-id="element-190" data-mp="1jeoh72cr7pxf">
          {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-stone-200' : ''}`} data-id="element-191" data-mp="19lzaeks5f08f" data-mpi={index}>
              <dt className="sr-only" data-id="element-192" data-mp="10m2sr346f1mv">{stat.label}</dt>
              <dd data-id="element-193" data-mp="10nnnotuekml9">
                <span className="block text-3xl font-black text-stone-900 sm:text-4xl" data-id="element-194" data-mp="10jzqnkpr1i1s">
                  {stat.value}
                </span>
                <span className="mt-1 block text-[10px] font-bold uppercase tracking-[0.16em] text-stone-500 sm:text-xs" data-id="element-195" data-mp="qnd8x4spz73z">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}